// extracted by mini-css-extract-plugin
export var container = "_9w-0";
export var error = "_9w-9";
export var label = "_9w-5";
export var light = "_9w-6";
export var md = "_9w-3";
export var sm = "_9w-2";
export var thin = "_9w-8";
export var thinBold = "_9w-7";
export var vertical = "_9w-4";
export var xs = "_9w-1";